"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _PromotionBlockModule = _interopRequireDefault(require("../../scss/blocks/PromotionBlock.module.scss"));
function PromotionBlock({
  image,
  promo
}) {
  const promoCopyRef = (0, _react.useRef)();
  const promoImageRef = (0, _react.useRef)();
  const triggerAnimation = (entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        promoCopyRef.current.classList.add(`${_PromotionBlockModule.default['promo-copy--animate']}`);
        promoImageRef.current.classList.add(`${_PromotionBlockModule.default['promo-image--animate']}`);
        observer.unobserve(promoImageRef.current);
      }
    });
  };
  (0, _react.useEffect)(() => {
    const promoimageObserver = new IntersectionObserver(triggerAnimation, {
      root: null,
      rootMargin: "0px",
      threshold: 0.1
    });
    promoimageObserver.observe(promoImageRef.current);
    return () => {
      promoimageObserver.disconnect();
    };
  }, []);
  return /*#__PURE__*/_react.default.createElement("promotion-block", null, /*#__PURE__*/_react.default.createElement("div", {
    className: _PromotionBlockModule.default['promo-image'],
    ref: promoImageRef
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: _PromotionBlockModule.default['promo-image__text']
  }, image.text), /*#__PURE__*/_react.default.createElement("promo-image", null, /*#__PURE__*/_react.default.createElement("a", {
    href: promo.href,
    target: "_blank",
    rel: "noreferrer"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: image.url,
    alt: image.altText
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: _PromotionBlockModule.default['promo-copy'],
    ref: promoCopyRef
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: _PromotionBlockModule.default['promo-copy__header']
  }, promo.header), /*#__PURE__*/_react.default.createElement("p", {
    className: _PromotionBlockModule.default['promo-copy__description']
  }, promo.description), /*#__PURE__*/_react.default.createElement("a", {
    className: _PromotionBlockModule.default['promo-copy__link'],
    href: promo.href,
    target: "_blank",
    rel: "noreferrer"
  }, promo.linkText)));
}
var _default = exports.default = PromotionBlock;